<script setup>
import {defineProps, watch} from "vue";
import Check from "../../../../../../franchise-listings/assets/svg/Check.svg";
import debounce from "../../../../debounce";

const {flowState} = defineProps(['visible', 'flowState']);

const sendToHubspot = async () => {
  try {
			// Send to Hubspot
      await flowState.services.submitData(flowState.userData());
      flowState.checkLimits();
  } catch (e) {
    console.log(e)
  }
};

if (flowState.getHubspotStatus()) {
  sendToHubspot()
}

const stopAndClose = () => {
  flowState.stopCountdown();
  flowState.close();
}

watch(
    () => flowState.getHubspotStatus(),
    debounce(() => {
      if (flowState.getHubspotStatus()) {
        sendToHubspot()
      }
    }, 1000)
);

</script>

<template>
  <div v-if="visible">
    <div class="tab">
      <div class="row pb-3 success-submit">
	      <template v-if="flowState.getLeadSource() === 'Brochure request'">
		      <p class="fw-bold congrats mb-3">
			      Your request has been submitted. You will receive the brochure on your email shortly.
		      </p>
	      </template>
	      <template v-else-if="flowState.getLeadSource() === 'Specialist pop up' || flowState.getLeadSource() === 'Franchise specialist cta'">
		      <p class="fw-bold congrats mb-3">
			      Your request has been submitted. A franchise specialist in our network will reach out soon.
		      </p>
		      <p class="fw-normal" v-if="flowState.getConsultWithFranchiseSpecialist() === 'Yes'">
			      <Check/>
			      Please be on the lookout for a call, text, or email shortly.
		      </p>
	      </template>
      </div>
    </div>
  </div>
</template>
